import { Stack, Tooltip } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

interface InfoLabelProps {
  /** The label text. */
  label: string
  /** The tooltip text shown when hovering the info icon. */
  tooltip: string
}

/**
 * A form field label with a small info icon that shows a tooltip on hover.
 *
 * @example
 * ```tsx
 * <HookFormSelect
 *   name="licenseType"
 *   label={<InfoLabel label="License Type" tooltip="Lite provides basic access..." />}
 * />
 * ```
 */
export function InfoLabel({ label, tooltip }: InfoLabelProps) {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      component="span"
      sx={{
        alignItems: 'center',
      }}
    >
      <span>{label}</span>
      <Tooltip title={tooltip} disableInteractive>
        <InfoIcon sx={{ fontSize: 18, color: 'action.active', cursor: 'help' }} />
      </Tooltip>
    </Stack>
  )
}
